import { render, staticRenderFns } from "./InputAttribute.vue?vue&type=template&id=507fc41e"
import script from "./InputAttribute.vue?vue&type=script&lang=ts"
export * from "./InputAttribute.vue?vue&type=script&lang=ts"
import style0 from "./InputAttribute.vue?vue&type=style&index=0&id=507fc41e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports